// import "./welComePage.scss";
import "./getDetailsPage.scss";
import React, { useState } from "react";
import { MenuItem, TextField, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useLocation } from "react-router-dom";
import { genderOptions } from "../../Constants/Constants";
import { countries } from "../../Constants/Countries";
import { useNavigate } from "react-router-dom";

const GetDetailsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const responseString = queryParams.get("response");

  const response = responseString
    ? JSON.parse(decodeURIComponent(responseString))
    : null;

  const extractDetils = response.data.message;
  const checkInDate = extractDetils.Arriving_DateTime.split("T")[0];
  const checkOutDate = extractDetils.Depature_DateTime.split("T")[0];

  const [data, setData] = useState({});
  const [formList, setFormList] = useState({
    Fname: extractDetils.Customer_Fname,
    Lname: extractDetils.Customer_Lname,
    Gender: "",
    DOB: null,
    Age: "20",
    City: "",
    Country: "",
    ContactNumber: extractDetils.Contact_Number,
    FileName: null,
    Arriving_DateTime: extractDetils.Arriving_DateTime,
    Depature_DateTime: extractDetils.Depature_DateTime,
    Num_Of_Adults: extractDetils.Num_Of_Adults,
    Num_Of_Kids: extractDetils.Num_Of_Kids,
  });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormList((prevForm) => ({
        ...prevForm,
        FileName: file,
      }));
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormList((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  // const handleDateChange = (newValue) => {
  //   setFormList((prev) => ({
  //     ...prev,
  //     DOB: newValue,
  //   }));
  // };

  const handleDateChange = (newValue) => {
    setFormList((prev) => ({
      ...prev,
      DOB: newValue ? newValue.format("YYYY-MM-DD") : "",
    }));
  };

  const handleClick = () => {
    console.log("formList ", formList);
    navigate("/addguestdetails", { state: { formData: formList } });
  };

  return (
    <div className="getDetailsPage">
      <div className="formList">
        <div className="inputs">
          <div className="inputs-top">
            <div className="inputs-Left">
              <TextField
                className="textField"
                id="outlined-basic"
                name="Fname"
                type="text"
                label="First name"
                required
                variant="outlined"
                value={formList.Fname}
                onChange={handleChange}
                disabled
              />
              <TextField
                className="textField"
                id="outlined-basic"
                name="ContactNumber"
                type="text"
                label="Contact Number"
                required
                variant="outlined"
                value={formList.ContactNumber}
                onChange={handleChange}
                disabled
              />
              <TextField
                className="textField"
                id="gender"
                name="Gender"
                select
                label="Gender"
                required
                variant="outlined"
                value={formList.Gender}
                onChange={handleChange}
              >
                {genderOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                className="textField"
                id="outlined-basic"
                name="City"
                type="text"
                label="City"
                required
                variant="outlined"
                value={formList.City}
                onChange={handleChange}
              />
              <TextField
                className="textField"
                id="outlined-basic"
                // name="Lname"
                type="text"
                label="Check Out Date"
                required
                variant="outlined"
                value={checkOutDate}
                onChange={handleChange}
                disabled
              />
              <TextField
                className="textField"
                id="outlined-basic"
                // name="Lname"
                type="text"
                label="Number of Kids"
                required
                variant="outlined"
                value={formList.Num_Of_Kids}
                onChange={handleChange}
                disabled
              />
            </div>
            <div className="inputs-Right">
              {" "}
              <TextField
                className="textField"
                id="outlined-basic"
                name="Lname"
                type="text"
                label="Last name"
                required
                variant="outlined"
                value={formList.Lname}
                onChange={handleChange}
                disabled
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth Day"
                  value={formList.DOB}
                  maxDate={dayjs()}
                  onChange={handleDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      className="textField"
                      name="DOB"
                      id="outlined-basic"
                    />
                  )}
                />
              </LocalizationProvider>
              <TextField
                className="textField"
                id="outlined-basic"
                name="Country"
                select
                label="Country"
                required
                variant="outlined"
                value={formList.Country}
                onChange={handleChange}
              >
                {countries.map((option) => (
                  <MenuItem key={option.ID} value={option.name}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                className="textField"
                id="outlined-basic"
                // name="Lname"
                type="text"
                label="Check In Date"
                required
                variant="outlined"
                value={checkInDate}
                onChange={handleChange}
                disabled
              />
              <TextField
                className="textField"
                id="outlined-basic"
                // name="Lname"
                type="text"
                label="Number of Adults"
                required
                variant="outlined"
                value={formList.Num_Of_Adults}
                onChange={handleChange}
                disabled
              />
              <div style={{ marginTop: "25px", position: "absolute" }}>
                <div>
                  <input
                    accept="image/*,application/pdf" // allow png, pdf, jpg etc
                    style={{ display: "none" }}
                    id="upload-file"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label htmlFor="upload-file">
                    <Button
                      variant="contained"
                      component="span"
                      sx={{
                        position: "relative",
                        backgroundColor: "green",
                        "&:hover": {
                          backgroundColor: "darkgreen",
                        },
                      }}
                    >
                      Upload File
                    </Button>
                  </label>

                  {formList.FileName && (
                    <div style={{ marginTop: "10px" }}>
                      Selected File: {formList.FileName.name}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="inputs-bottom">
            <div className="button-left"></div>
            <div className="button-right">
              <button onClick={() => {}}>Cancel</button>
              <button onClick={handleClick}>Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetDetailsPage;
